import React from "react";
import { Button as AntdButton } from "antd";
import cx from "classnames";
import styles from "./Button.module.scss";
interface ButtonProps {
  children?: React.ReactNode;
  label?: string | React.ReactNode;
  type?: "primary" | "default" | "dashed" | "link" | "text";
  size?: "small" | "middle" | "large";
  onClick?:
    | (() => void)
    | ((e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void);
  disabled?: boolean;
  light?: boolean;
  className?: string;
  [key: string]: unknown;
}

const Button: React.FC<ButtonProps> = ({
  children,
  type = "primary",
  size = "middle",
  onClick,
  disabled,
  label = "",
  light = false,
  className,
  ...props
}) => {
  return (
    <AntdButton
      className={cx(
        styles.button,
        {
          [styles.light]: light,
        },
        className || ""
      )}
      type={type}
      size={size}
      onClick={onClick}
      disabled={disabled}
      {...props}
    >
      {children ? children : label}
    </AntdButton>
  );
};

export default Button;
